<template>
  <footer id="footer">
    <div class="info first" @click="clearContentCache">
      <p class="copyright" v-html="footer.copyright__left"></p>
    </div>
    <div class="info last">
      <p class="developed-by" v-html="footer.credits__right"></p>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PageFooter",
  computed: {
    ...mapGetters(["main"]),
    footer() {
      if (this.main.footer) {
        return this.main.footer;
      } else {
        return {};
      }
    }
  },
  methods: {
    clearContentCache() {
      this.$parent.clearContentCache();
    }
  }
};
</script>